import PropTypes from 'prop-types';
import React from 'react';
export const MissingComponent = (props) => {
    const componentName = props.rendering && props.rendering.componentName
        ? props.rendering.componentName
        : 'Unnamed Component';
    // error override would mean component is not unimplemented
    !props.errorOverride &&
        console.log(`Component props for unimplemented '${componentName}' component`, props);
    const errorMessage = props.errorOverride ||
        'JSS component is missing React implementation. See the developer console for more information.';
    return (React.createElement("div", { style: {
            background: 'darkorange',
            outline: '5px solid orange',
            padding: '10px',
            color: 'white',
            maxWidth: '500px',
        } },
        React.createElement("h2", null, componentName),
        React.createElement("p", null, errorMessage)));
};
MissingComponent.propTypes = {
    rendering: PropTypes.shape({
        componentName: PropTypes.string,
    }),
};
MissingComponent.displayName = 'MissingComponent';
